import { useAtom } from 'jotai';
import { userAtom } from '@/store';

export default function useLogin() {
  const [user] = useAtom(userAtom);
  const isLogin = !!user.accessToken;

  return {
    isLogin,
  }
}